module.exports = __webpack_public_path__ + "img/coinbankB01.56169b59.jpg";